import "@fontsource/roboto-slab";
import "@fontsource/arimo";
import "./reset.css";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/globals.css";
import "./globals.css";
import "./digicgt.sass";

import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { trackRouteChange } from "./analytics/wrappers";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: false,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

router.subscribe("onBeforeNavigate", ({ toLocation }) => {
  trackRouteChange(toLocation.pathname);
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
  createRoot(rootElement).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}

// Reload the page if there is a preload error,
// which will happen if we deploy new code
window.addEventListener("vite:preloadError", (event) => {
  window.location.reload(); // refresh the page
  event.preventDefault();
});
